import { Switch } from "@mui/material"

const CustomSwitch = ({ sx = {}, activeColor = "#4caf50", ...props }) => {
  const baseSx = {
    width: 46,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: "2px",
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(20px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: activeColor,
          opacity: 1,
          border: 0,
        },
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 13,
      backgroundColor: "#E9E9EA",
      opacity: 1,
    },
  }

  return <Switch {...props} sx={{ ...baseSx, ...sx }} />
}

export default CustomSwitch